import { render } from "./LuckyValue.vue?vue&type=template&id=4dad2691&scoped=true&bindings={}"
import script from "./LuckyValue.vue?vue&type=script&lang=ts"
export * from "./LuckyValue.vue?vue&type=script&lang=ts"

import "./LuckyValue.vue?vue&type=style&index=0&id=4dad2691&scoped=true&lang=less"
script.render = render
script.__scopeId = "data-v-4dad2691"

export default script